import BuildingOutlineSvg from '@assets/images/svg/building-outline.svg';
import React from 'react';
import { View } from 'react-native';

export interface BuildingOutlineIconProps {
  size?: number;
  color?: string;
}

/** Outline building icon (Figma "About Property" section icon). */
export function BuildingOutlineIcon({
  size = 24,
  color = '#333333',
}: Readonly<BuildingOutlineIconProps>) {
  return (
    <View
      style={{
        width: size,
        height: size,
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <BuildingOutlineSvg width={size} height={size} color={color} />
    </View>
  );
}

export default BuildingOutlineIcon;
